



















































































































import { Component, Vue } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import Select from '@/components/Select.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import TagInput from '@/components/TagInput.vue';
import api from '@/libs/api';
import {
  GroupApiResponse, RoleApiResponse, Group, Role,
} from '@/libs/api.interfaces';

Vue.use(VueRouter);

@Component({
  components: {
    LayoutTitle,
    Select,
    TagInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Loader,
  },
})
export default class UserListFilter extends Vue {
  name: { key: string; value: string }[] = [];
  status: string[] = [];
  email: { key: string; value: string }[] = [];
  groups: Group[] = [];
  group: Group[] = [];
  roles: Role[] = [];
  role: Role[] = [];

  loadingMerchant = false;
  showFilterMerchant = false;

  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  selectedMerchants: { merchant_code: string; merchant_name: string } | null = null;

  filter() {
    this.$router.push({
      query: {
        name: this.name.length === 0 ? undefined : this.name.map((e) => e.value).join(','),
        email: this.email.length === 0 ? undefined : this.email.map((e) => e.value).join(','),
        status: this.status.length === 0 ? undefined : this.status.join(','),
        group: this.group.length === 0 ? undefined : this.group.map((e) => e.id.toString()).join(','),
        role: this.role.length === 0 ? undefined : this.role.map((e) => e.id.toString()).join(','),
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: this.selectedMerchants === null ? undefined : this.selectedMerchants.merchant_code,
        merchant_name: this.selectedMerchants === null ? undefined : this.selectedMerchants.merchant_name,
      },
    });
  }

  async mounted() {
    await Promise.all([this.getGroup(), this.getRole()]);
    this.parseParams();
    const data = JSON.parse(localStorage.getItem('USER') || '{}');
    if (this.$route.params.type === 'external') {
      if (data.user.is_internal === 1) {
        this.showFilterMerchant = true;
      }
    }
  }

  clear() {
    this.name = [];
    this.status = [];
    this.email = [];
    this.role = [];
    this.group = [];
    this.selectedMerchants = null;
    this.$router.push({
      query: {
        name: undefined,
        status: undefined,
        email: undefined,
        group: undefined,
        role: undefined,
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: undefined,
      },
    });
  }

  async getGroup() {
    try {
      const { data } = await api.get<GroupApiResponse>('/user-groups', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: this.type === 'internal',
        },
      });
      this.groups = data.data.items;
    } catch (err) {
      console.error(err);
    }
  }

  async getRole() {
    try {
      const { data } = await api.get<RoleApiResponse>('/user-roles', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: this.type === 'internal',
        },
      });
      this.roles = data.data;
    } catch (err) {
      console.error(err);
    }
  }

  async getMerchants(query: string, value: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const params: any = {};
      params[query] = value;
      const { data } = await api.get('/consumer/merchant', {
        params,
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.name === 'string') {
      this.name = params.name.split(',').map((e) => ({ key: '', value: e }));
    }

    if (typeof params.status === 'string') {
      this.status = params.status.split(',');
    }

    if (typeof params.email === 'string') {
      this.email = params.email.split(',').map((e) => ({ key: '', value: e }));
    }

    if (typeof params.group === 'string') {
      const group = params.group.split(',');
      this.group = this.groups.filter((e) => group.includes(e.id.toString()));
    }

    if (typeof params.role === 'string') {
      const role = params.role.split(',');
      this.role = this.roles.filter((e) => role.includes(e.id.toString()));
    }

    let merchantCode = '';
    if (typeof params.merchant_code === 'string') {
      merchantCode = params.merchant_code;
    }

    let merchantName = '';
    if (typeof params.merchant_name === 'string') {
      merchantName = params.merchant_name;
    }

    if (merchantCode !== '' && merchantName !== '') {
      this.selectedMerchants = {
        merchant_code: merchantCode,
        merchant_name: merchantName,
      };
    }
  }

  get type() {
    return this.$route.params.type;
  }
}
